export function testAttribute(...args: Array<string | number | undefined>) {
  const ret = args.filter(s => s !== undefined).join('-').replace(/\s+/g, '-').toLowerCase().replace('-(test)', '');
  return ret.length > 0 ? ret : undefined;
}

export function testAttributeWithPrefix(defaultValue: string, value?: string, dataTestPrefix?: string) {
  const dataTestSuffix = testAttribute(value || defaultValue);
  if (!dataTestPrefix) return dataTestSuffix;
  return `${dataTestPrefix}-${dataTestSuffix}`;
}
